/* eslint-disable import/no-cycle */
import React, { useMemo, useCallback } from "react";
import Box from "../Box";
import ClearInputIcon from "@pixel/assets/icons/ClearInput";
import NumberField from "../NumberField";
import { createEmptyAppliedFilter } from '.';
const ListFilterNumber = /*#__PURE__*/React.forwardRef((_ref2, _ref) => {
  let {
    searchFilter,
    appliedSearchFilter,
    onChangeAppliedFilter
  } = _ref2;
  const appliedFilterValues = useMemo(() => {
    return (appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues.length) > 0 ? appliedSearchFilter.filterValues : [];
  }, [appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues //needed to shallow compare changes
  ]);
  const handleChangeValue = useCallback(e => {
    const value = e.target.value;
    if (value != null) {
      const filterValues = []; //Note: even though its single select we commonize the way we pass back data in an array
      const filterValue = {
        value: value + "",
        //because we only accept strings
        label: value + "",
        context: null
      };
      filterValues.push(filterValue);
      const newAppliedSearchFilter = appliedSearchFilter ? appliedSearchFilter : createEmptyAppliedFilter(searchFilter);
      newAppliedSearchFilter.filterValues = filterValues;
      newAppliedSearchFilter.displayLabel = "".concat(searchFilter.label, ": ").concat(value);
      onChangeAppliedFilter(searchFilter, newAppliedSearchFilter);
    } else {
      onChangeAppliedFilter(searchFilter, null);
    }
  }, [searchFilter, appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues,
  //needed to shallow compare changes 
  onChangeAppliedFilter, createEmptyAppliedFilter]);
  const handleClear = e => {
    onChangeAppliedFilter(searchFilter, null);
  };
  const value = (appliedFilterValues === null || appliedFilterValues === void 0 ? void 0 : appliedFilterValues.length) > 0 ? appliedFilterValues[0].value : "";
  const {
    minValue = 0,
    maxValue = 100,
    step = 1
  } = searchFilter;
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(NumberField, {
    id: "".concat(searchFilter.id),
    fullWidth: true,
    onChange: handleChangeValue,
    label: null,
    ariaLabel: searchFilter.label,
    value: value,
    placeholder: searchFilter.placeholder,
    min: minValue,
    max: maxValue,
    step: step,
    endingButtonProps: {
      ariaLabel: "Clear",
      icon: ClearInputIcon,
      onClick: handleClear,
      disabled: true
    }
  }));
});
export default ListFilterNumber;